module.exports = __webpack_public_path__ + "static/img/a105.c704868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a105.jpg
// module id = n4cC
// module chunks = 0